import { formatPrice } from '@lichtblick/localization';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { Footnote } from '@lichtblick/photon/molecules/footnote/footnote';
import { BonusParagraph, BonusPriceSection } from '@/components/tariff-details-layer/bonus';
import { LegalInformation } from '@/components/tariff-details-layer/legal-information';
import { ModalHeadline } from '@/components/tariff-details-layer/modal-headline';
import { PriceWrapper } from '@/components/tariff-details-layer/price-wrapper';
import { TariffDetailsModal } from '@/components/tariff-details-layer/tariff-details-modal';
import { getCurrentMonth } from '../../helpers/date';
import type { TariffsQuery } from '../../types/generated';
import { PriceBreakdownList } from '../price-breakdown/price-breakdown-list';
import { PriceBreakdownRow } from '../price-breakdown/price-breakdown-row';
import { MonthlyPrices } from './monthly-prices';
import { VarioVideo } from './vario-video';

type VarioTariffDetailsLayerProps = {
  index: number;
  isComboCheckout: boolean;
  product: TariffsQuery['tariffs'][number];
  renderLinkAs?: 'link' | 'button';
};

export const VarioTariffDetailsLayer: React.FC<VarioTariffDetailsLayerProps> = ({
  index = -1,
  isComboCheckout,
  product,
  renderLinkAs = 'link',
}) => {
  return (
    <TariffDetailsModal index={index} isComboCheckout={isComboCheckout} product={product} renderLinkAs={renderLinkAs}>
      <ModalHeadline>{product.name} - Tarifdetails</ModalHeadline>

      <MonthlyPrices product={product} />

      <PriceWrapper>
        <Text bold size="l">
          Voraussichtliche Kosten
        </Text>

        <PriceBreakdownList>
          <PriceBreakdownRow label="Laufzeit" value="keine" />
          <PriceBreakdownRow label="Preisgarantie" value="keine" />
        </PriceBreakdownList>

        <PriceBreakdownList>
          <PriceBreakdownRow
            label={`Arbeitspreis im ${getCurrentMonth()}¹`}
            value={formatPrice(product.workPrice, 'ct/kWh')}
          />
          <PriceBreakdownRow label="Monatl. Grundpreis" value={formatPrice(product.monthlyBasePrice)} />

          <PriceBreakdownRow
            isBold
            label={`Abschlag im ${getCurrentMonth()}¹`}
            value={formatPrice(product.monthlyPriceWithBonus)}
          />
          <PriceBreakdownRow
            isBold
            label={`Voraussichtliche Jahreskosten (${product.usage} kWh)`}
            value={formatPrice(product.totalPriceNoBonus)}
          />
        </PriceBreakdownList>

        <BonusPriceSection product={product} />
      </PriceWrapper>

      <BonusParagraph product={product} />

      <VarioVideo />

      <LegalInformation product={product} />

      <Footnote index="1">
        Der Arbeitspreis ändert sich monatlich und orientiert sich an den aktuellen Preisen der Strombörse. Beim
        angegebenen Arbeitspreis und Abschlag handelt es sich somit um Richtwerte. Dein Abschlag wird monatlich mit der
        Änderung des Arbeitspreises angepasst.
      </Footnote>
    </TariffDetailsModal>
  );
};
